import { Phone } from "lucide-react";
import { site } from "@/config/site";
import { useLeadForm } from "@/components/lead/LeadForm";
import { trackEvent } from "@/lib/tracking";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.5 0 1.47 1.07 2.89 1.22 3.09.15.2 2.11 3.22 5.1 4.51.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.58-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35M12.05 21.79h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.83 9.83 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.9-9.88a9.82 9.82 0 0 1 9.88 9.89c0 5.45-4.44 9.88-9.89 9.88m8.42-18.29A11.8 11.8 0 0 0 12.04 0C5.5 0 .16 5.34.16 11.9c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.9 11.9 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.9 0-3.18-1.24-6.16-3.48-8.4" />
  </svg>
);

export function MobileBar() {
  const { openForm } = useLeadForm();
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden border-t border-navy-800 bg-navy-900 shadow-2xl"
      data-testid="mobile-conversion-bar"
    >
      <div className="grid grid-cols-3 gap-px bg-navy-800">
        <a
          href={site.phone.href}
          data-testid="mobile-bar-call-btn"
          onClick={() => trackEvent("phone_click", { location: "mobile_bar" })}
          className="flex items-center justify-center gap-1.5 bg-navy-900 py-4 text-xs font-semibold text-white active:bg-navy-800"
        >
          <Phone className="h-4 w-4" /> Call
        </a>
        <a
          href={`${site.whatsapp.href}?text=${encodeURIComponent("Hi My Blinds Company — I'd like a free quote for blinds.")}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bar-whatsapp-btn"
          onClick={() => trackEvent("whatsapp_click", { location: "mobile_bar" })}
          className="flex items-center justify-center gap-1.5 bg-[#1faa55] py-4 text-xs font-semibold text-white active:bg-[#1a9449]"
        >
          <WhatsAppIcon className="h-4 w-4" /> WhatsApp
        </a>
        <button
          type="button"
          data-testid="mobile-bar-quote-btn"
          onClick={() => openForm({ source: "mobile_bar" })}
          className="flex items-center justify-center gap-1.5 bg-navy-800 py-4 text-xs font-semibold text-white active:bg-navy-900"
        >
          Free Quote
        </button>
      </div>
      <div className="h-[env(safe-area-inset-bottom)] bg-navy-900" />
    </div>
  );
}
